import React from 'react'
import TradingViewWidget from '../Terminal/TradingViewWidget'
import HeaderNew from '../Layout/Header/Header'

const Chart = () => {
    return (
        <>
            <HeaderNew />
            <div style={{  height: "calc(100vh - 200px)" ,paddingTop:'70px'}}>
                <h2 style={{paddingBottom:'10px'}}>Chart</h2>
                <TradingViewWidget />
            </div> 
        </>
    )
}

export default Chart